import { lazy, Suspense, useEffect } from 'react';

import { Routes, Route, useLocation, useNavigate } from 'react-router';

import { LoadingScreen } from '@/components';
import { ProspectingList } from '@/pages';
import { APP_ROUTES } from '@/routes';

const NotFoundPage = lazy(() => import('@/pages/Page404'));

export function Router() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      navigate(APP_ROUTES.default);
    }
  }, [location.pathname]);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route index path={APP_ROUTES.default} element={<ProspectingList />} />
        <Route path={APP_ROUTES.catchAll} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
